import { useState } from 'react';
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import MerchantPaymentsService from '../../../services/MerchantPaymentsService';
import { useLoaderContext } from '../../../contexts/Loader/LoaderContext';

const useQueryBulkRefunds = ({ initFilters = {} }) => {
  const { setIsLoaderOpen } = useLoaderContext();
  const [filters, setFilters] = useState(initFilters);

  const fetchPCancellations = async parameters => {
    try {
      setIsLoaderOpen(true);

      const responseCancellations =
        await MerchantPaymentsService().getBulkRefunds(parameters);

      setIsLoaderOpen(false);
      return responseCancellations;
    } catch (error) {
      setIsLoaderOpen(false);
      console.log(error);
    }
  };

  const queryResult = useQuery({
    queryKey: ['bulkRefunds', filters],
    queryFn: async () => fetchPCancellations(filters),
    placeholderData: keepPreviousData,
  });

  const onUpdateFilters = newFilters => {
    setFilters(prev => ({ ...prev, ...newFilters }));
  };

  const onChangePageSize = pageSize => {
    setFilters(prev => ({ ...prev, pageSize: Number(pageSize) }));
  };

  const onChangePage = page => {
    setFilters(prev => ({ ...prev, pageSize: Number(page) }));
  };

  return {
    filters: filters,
    changePage: onChangePage,
    changePageSize: onChangePageSize,
    updateFilters: onUpdateFilters,
    queryResult: queryResult,
  };
};

export default useQueryBulkRefunds;
